import { createContext, useContext, useState } from 'react';

const BlogContext = createContext();

export function BlogProvider({ children }) {
  const [currentBlogId, setCurrentBlog] = useState(null);
  
  return (
    <BlogContext.Provider value={{ currentBlogId, setCurrentBlog }}>
      {children}
    </BlogContext.Provider>
  );
}

export function useBlog() {
  return useContext(BlogContext);
}